<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <br><br>
    <p class="form__label">
      Staking $ERFC 
    </p>
    <br><br>
  
    
    <button class="button-36" @click="addTokenInWallet">
      Add ERFC token in Metamask  <img style="width: 50px;" src="../assets/mm.png">
    </button>
    

  </div>

  <br><br><br>
</template>

<script>
export default {
  name: 'MainPage',
  props: {
    msg: String
  }, data(){

},methods:{
      addTokenInWallet: function(){


      try {
        const params = {
        type: 'ERC20',
        options: {
          address: '0xBe055654011E1FD1CC141F96Bb2edAe4930dCa28',
          symbol: 'ERFC',
          decimals: 18,
          image: 'https://ipfs.io/ipfs/QmbCjx5uCdq2R2tXnFqzM9fWjhtrUR7Mq7whdt7saT4HAo'
        }
      }

      window.ethereum.request({ method: 'wallet_watchAsset', params })
        .then(() => console.log('Success, Token added!'))
        .catch((error) => console.log('Error: '+ error.message))




        /*
        // wasAdded is a boolean. Like any RPC method, an error may be thrown.
        const wasAdded = ethereum.request({
          method: 'wallet_watchAsset',
          params: {
            type: 'ERC20', // Initially only supports ERC20, but eventually more!
            options: {
              address: tokenAddress, // The address that the token is at.
              symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
              decimals: tokenDecimals, // The number of decimals in the token
              image: tokenImage, // A string url of the token logo
            },
          },
        });

        if (wasAdded) {
          console.log('Thanks for your interest!');
        } else {
          console.log('Your loss!');
        }*/
      } catch (error) {
        console.log(error);
      }
    }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}


.form__label {
  font-family: 'Roboto', sans-serif;
  font-size: 2.9rem;
  margin-left: 2rem;
  margin-top: 0.7rem;
  display: block;
  transition: all 0.3s;
  transform: translateY(0rem);
}

.form__input {
  font-family: 'Roboto', sans-serif;
  color: rgb(85, 85, 204);
  font-size: 1.8rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  background-color: rgb(40, 40, 53);
  border: none;
  width: 20%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
}



.form__input:placeholder-shown + .form__label {
  opacity: 0;
  visibility: hidden;
  -webkit-transform: translateY(-4rem);
  transform: translateY(-4rem);
}

*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
  font-size: 62,5%;
}




.button-36 {
  background-image: linear-gradient(92.88deg, #455EB5 9.16%, #5643CC 43.89%, #673FD7 64.72%);
  border-radius: 8px;
  border-style: none;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  flex-shrink: 0;
  font-family: "Inter UI","SF Pro Display",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Open Sans","Helvetica Neue",sans-serif;
  font-size: 16px;
  font-weight: 500;
  height: 4rem;
  padding: 0 1.6rem;
  text-align: center;
  text-shadow: rgba(0, 0, 0, 0.25) 0 3px 8px;
  transition: all .5s;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  display: inline-flex;
  align-items: center; 
}

.button-36:hover {
  box-shadow: rgba(80, 63, 205, 0.5) 0 1px 30px;
  transition-duration: .1s;
}

@media (min-width: 768px) {
  .button-36 {
    padding: 0 2.6rem;
  }
}
</style>
